import { filterConstants } from '../constants'

const cleanAll = () => ({
    type: filterConstants.CLEANALL,
})

const cleanResend = () => ({
    type: filterConstants.CLEANRESEND
})

const cleanHistory = () => ({
    type: filterConstants.CLEANHISTORY
})

const cleanStates = () => ({
    type: filterConstants.CLEANSTATES
})

const cleanReassign = () => ({
    type: filterConstants.CLEANREASSIGN
})

const setResend = filtersResend => ({
    type: filterConstants.SETRESEND,
    filtersResend
})

const setHistory = filtersHistory => ({
    type: filterConstants.SETHISTORY,
    filtersHistory
})

const setReportStates = filtersState => ({
    type: filterConstants.SETSTATES,
    filtersState
})

const setReportReassign = filtersReassign => ({
    type: filterConstants.SETREASSIGN,
    filtersReassign
})

export const filterActions = {
    cleanAll,
    cleanResend,
    cleanHistory,
    cleanStates,
    cleanReassign,
    setResend,
    setHistory,
    setReportStates,
    setReportReassign,
}
